<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <div v-if="!couponCheck" class="content_title"><h3>{{$t('agencyPc.agencyAccount')}}</h3></div>
        <div v-if="couponCheck" class="content_title"><h3>{{$t('agencyPc.friendCashCoupon')}}</h3></div>
      </div>
      <el-tabs id="agencyTabs">
        <el-tab-pane style="margin-left: 20px">
          <h4 slot="label">{{$t('agencyPc.myPromotion')}}</h4>
          <div>
            <p v-if="!couponCheck">{{$t('agencyPc.scanToRegister')}}</p>
            <p v-if="couponCheck">{{$t('agencyPc.inviteFriendsToRegister')}}</p>
            <p v-if="couponCheck">
              {{$t('agencyPc.friendGift', {couponAmountMultiplied: couponAmount * 10,amount: couponAmount })}}
            </p>
            <p v-if="couponCheck">
              {{$t('agencyPc.afterAllocationFunds')}} {{(couponAmount + (couponAmount * 10))*10}} {{ $t('agencyPc.withdrawnCurrency') }}
            </p>

            <div v-if="couponCheck"><br /></div>
            <p v-if="couponCheck">{{$t('agencyPc.inviteFriendsToRegister')}}</p>

            <div id="qrcode" class="agency_qrcode"></div>
          </div>
          <div>
            <h4 v-if="couponCheck">{{$t('agencyPc.couponNumberPerPerson', {number: couponNo})}}</h4>
            <br />
          </div>

          <div v-if="!couponCheck">
            <h4>{{$t('agencyPc.methodTwo')}}</h4>
            <p style="margin-top: 10px">
              {{ agencyUrl
              }}<el-button
                type="danger"
                size="mini"
                @click="handleCopy(agencyUrl)"
                style="
                  color: var(--baseColor);
                  background: transparent;
                  border-color: var(--baseColor);
                  margin-left: 10px;
                "
                >{{$t('agencyPc.copyLink')}}</el-button
              >
            </p>
          </div>
          <div v-if="couponCheck">
            <h4>{{$t('agencyPc.methodTwo')}}</h4>
            <p style="margin-top: 10px">
              {{ agencyUrlSub
              }}<el-button
                type="danger"
                size="mini"
                @click="handleCopy(agencyUrlSub)"
                style="
                  color: var(--baseColor);
                  background: transparent;
                  border-color: var(--baseColor);
                  margin-left: 10px;
                "
                >{{$t('agencyPc.copyLink')}}</el-button
              >
            </p>
          </div>

          <div v-if="!couponCheck" style="margin-top: 20px">
            <h4>{{$t('agencyPc.methodThree')}}</h4>
            <p style="margin-top: 10px">
              {{ agencyUrl.split('=')[1]}}<el-button
                type="danger"
                size="mini"
                @click="handleCopy(code)"
                style="
                  color: var(--baseColor);
                  background: transparent;
                  border-color: var(--baseColor);
                  margin-left: 10px;
                "
                >{{$t('agencyPc.copyLink')}}</el-button
              >
            </p>
          </div>
          <div v-if="couponCheck" style="margin-top: 20px">
            <h4>{{$t('agencyPc.methodThree')}}</h4>
            <p style="margin-top: 10px">
              {{ couponNo
              }}<el-button
                type="danger"
                size="mini"
                @click="handleCopy(couponNo)"
                style="
                  color: var(--baseColor);
                  background: transparent;
                  border-color: var(--baseColor);
                  margin-left: 10px;
                "
                >{{$t('agencyPc.copyLink')}}</el-button
              >
            </p>
          </div>
        </el-tab-pane>
        <!-- ------------ second main tab ------------- -->
        <el-tab-pane id="isFromCoupon1" v-if="!couponCheck">
          <h4 slot="label"> {{$t('agencyPc.myCommission')}}</h4>

          <div>
            <el-row class="secondTabDetailBox">
              <el-col :span="3" style="text-align: center; line-height: 30px">
                <p>{{$t('agencyPc.commissionBalance')}}</p>
                <p>
                  <span class="integer-value">{{ agent_account }}</span>
                  <span class="decimal-value">{{$t('operateday.yuan')}}</span>
                </p>
              </el-col>
              <el-col :span="3" style="text-align: center; line-height: 30px">
                <p>{{$t('agencyPc.managementCommission')}}</p>
                <p>
                  <span class="integer-value">{{ manage_total }}</span>
                  <span class="decimal-value">{{$t('operateday.yuan')}}</span>
                </p>
              </el-col>
              <el-col :span="3" style="text-align: center; line-height: 30px">
                <p>{{$t('agencyPc.deferredFee')}}</p>
                <p>
                  <span class="integer-value">{{ deferred_total }}</span>
                  <span class="decimal-value">{{$t('operateday.yuan')}}</span>
                </p>
              </el-col>
              <el-col :span="3" style="text-align: center; line-height: 30px">
                <p>{{$t('agencyPc.profitSharing')}}</p>
                <p>
                  <span class="integer-value">{{ divide_total }}</span>
                  <span class="decimal-value">{{$t('operateday.yuan')}}</span>
                </p>
              </el-col>
              <el-col :span="3" style="text-align: center; line-height: 30px">
                <p>{{$t('agencyPc.withdrawAndTransfer')}}</p>
                <p>
                  <span class="integer-value">{{ wit_total }}</span>
                  <span class="decimal-value">{{$t('operateday.yuan')}}</span>
                </p>
              </el-col>
              <el-col :span="9" style="text-align: right">
                <!-- <el-button
                  type="primary"
                  @click="getConfig(); withdrawState = true"
                  style="
                    color: var(--baseColor);
                    background: #ffffff;
                    border-color: #ffffff;
                    padding: 9px 24px;
                  "
                  >{{$t('agencyPc.withdraw')}}</el-button
                > -->
                <el-button
                  type="warning"
                  @click="transferState = true"
                  style="
                    color: #ffffff;
                    background: transparent;
                    border-color: #ffffff;
                    padding: 9px 24px;
                  "
                  >{{$t('agencyPc.transfer')}}</el-button
                >
              </el-col>
            </el-row>
          </div>
          <el-tabs stretch>
            <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.commissionShare')}}</h4>
              <el-table :data="commissionDetails" style="width: 100%">
                <el-table-column
                  align="center"
                  prop="capital_order"
                  :label="$t('agencyPc.fundingAccount')"
                >
                </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="user_name" :label="$t('agencyPc.member')">
                </el-table-column>
                <el-table-column align="center" :label="$t('agencyPc.amount')">
                  <template slot-scope="scope">
                    <p
                      v-bind:style="
                        scope.row.mold == 0 ? 'color:red' : 'color:green'
                      "
                    >
                      {{ scope.row.mold == 0 ? "" : "-" }}{{ scope.row.number }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.withdrawTotal')}}</h4>
              <el-table :data="withdrawData" style="width: 100%">
                <el-table-column align="center" prop="remark" :label="$t('agencyPc.withdrawAndTransfer')">
                </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="statustext" :label="$t('agencyPc.status')">
                </el-table-column>
                <el-table-column align="center" prop="number" :label="$t('agencyPc.amount')">
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.managementFeeDetails')}}</h4>
              <el-table :data="manageData" style="width: 100%">
                <el-table-column
                  align="center"
                  prop="capital_order"
                  :label="$t('agencyPc.fundingAccount')"
                >
                </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="user_name" :label="$t('agencyPc.member')">
                </el-table-column>
                <el-table-column align="center" prop="number" :label="$t('agencyPc.amount')">
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.deferredFeeDetails')}}</h4>
              <el-table :data="deferredData" style="width: 100%">
                <el-table-column
                  align="center"
                  prop="capital_order"
                  :label="$t('agencyPc.fundingAccount')"
                >
                </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="user_name" :label="$t('agencyPc.member')">
                </el-table-column>
                <el-table-column align="center" prop="number" :label="$t('agencyPc.amount')">
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.profitSharingDetails')}}</h4>
              <el-table :data="dividedData" style="width: 100%">
                <el-table-column
                  align="center"
                  prop="capital_order"
                  :label="$t('agencyPc.fundingAccount')"
                >
                </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="user_name" :label="$t('agencyPc.member')">
                </el-table-column>
                <el-table-column align="center" prop="number" :label="$t('agencyPc.amount')">
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
              <!-- remove member recharge reward details -->
              <!-- <el-tab-pane>
              <h4 slot="label">{{$t('agencyPc.memberRechargeRewardDetails')}}</h4>
              <el-table :data="voucherData" style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="capital_order"
                    :label="$t('agencyPc.fundingAccount')">
                  </el-table-column>
                <el-table-column align="center" prop="type" :label="$t('agencyPc.type')">
                </el-table-column>
                <el-table-column align="center" prop="time" :label="$t('agencyPc.time')">
                </el-table-column>
                <el-table-column align="center" prop="user_name" :label="$t('agencyPc.member')">
                </el-table-column>
                <el-table-column align="center" prop="number" :label="$t('agencyPc.amount')">
                </el-table-column>
                <el-table-column align="center" prop="balance" :label="$t('agencyPc.balance')">
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
          </el-tabs>
        </el-tab-pane>
        <!-- ------------ third main tab ------------- -->
        <el-tab-pane id="isFromCoupon2" v-if="!couponCheck">
          <h4 slot="label">{{$t('agencyPc.myMember')}}</h4>
          <div id="couponTabs">
            <el-card>
              <el-tabs type="card">
                <el-tab-pane>
                  <h4 slot="label">{{$t('agencyPc.allMembers')}}</h4>
                  <el-row>
                    <el-col :span="6">
                      <div class="center">
                        <h3>{{$t('agencyPc.memberToday')}}</h3>
                        <p>
                          <span class="red">{{ todayNum }}</span
                          >人
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="center">
                        <h3>{{$t('agencyPc.firstClassMember')}}</h3>
                        <p>
                          <span class="red">{{ levelOne }}</span
                          >人
                        </p>
                      </div>
                    </el-col>
                    <!-- <el-col :span="6">
                      <div class="center">
                        <h3>{{$t('agencyPc.secondaryMember')}}</h3>
                        <p>
                          <span class="red">{{ levelTwo }}</span
                          >人
                        </p>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="center">
                        <h3>{{$t('agencyPc.levelThreeMember')}}</h3>
                        <p>
                          <span class="red">{{ levelThree }}</span
                          >人
                        </p>
                      </div>
                    </el-col> -->
                  </el-row>
                  <div style="margin-top: 10px">
                    <el-table :data="teamData" style="width: 100%">
                      <el-table-column
                        align="center"
                        prop="number"
                        :label="$t('agencyPc.memberNo')"
                      >
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="user_name"
                        :label="$t('agencyPc.memberName')"
                      >
                      </el-table-column>
                      <el-table-column align="center" prop="phone" label="手机号">
                      </el-table-column>
                      <!-- <el-table-column align="center" prop="vip" label="会员等级">
                      </el-table-column> -->
                      <el-table-column
                        align="center"
                        prop="level"
                        :label="$t('agencyPc.agentLevel')"
                      >
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="first_voucher"
                        :label="$t('agencyPc.firstChargeAmount')"
                      >
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="rec_total"
                        :label="$t('agencyPc.totalRecharge')"
                      >
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="time"
                        :label="$t('agencyPc.time')"
                        width="150px"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>
                <el-tab-pane>
                  <h4 slot="label">{{$t('agencyPc.rechargeMember')}}</h4>
                  <el-table :data="rechargeTeamData" style="width: 100%">
                    <el-table-column align="center" prop="number" :label="$t('agencyPc.memberNo')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="user_name"
                      :label="$t('agencyPc.memberName')"
                    >
                    </el-table-column>
                    <el-table-column align="center" prop="phone" :label="$t('agencyPc.phoneNumber')">
                    </el-table-column>
                    <!-- <el-table-column align="center" prop="vip" :label="$t('agencyPc.membershipLevel')">
                    </el-table-column> -->
                    <el-table-column align="center" prop="level" :label="$t('agencyPc.agentLevel')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="first_voucher"
                      :label="$t('agencyPc.firstChargeAmount')"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="rec_total"
                      :label="$t('agencyPc.totalRecharge')"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="time"
                      :label="$t('agencyPc.time')"
                      width="150px"
                    >
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane>
                  <h4 slot="label">{{$t('agencyPc.myMemberSub')}}</h4>
                  <el-table :data="noRechargeTeamData" style="width: 100%">
                    <el-table-column align="center" prop="number" :label="$t('agencyPc.memberNo')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="user_name"
                      :label="$t('agencyPc.memberName')"
                    >
                    </el-table-column>
                    <el-table-column align="center" prop="phone" :label="$t('agencyPc.phoneNumber')">
                    </el-table-column>
                    <!-- <el-table-column align="center" prop="vip" :label="$t('agencyPc.membershipLevel')">
                    </el-table-column> -->
                    <el-table-column align="center" prop="level" :label="$t('agencyPc.agentLevel')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="first_voucher"
                      :label="$t('agencyPc.firstChargeAmount')"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="rec_total"
                      :label="$t('agencyPc.totalRecharge')"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="time"
                      :label="$t('agencyPc.time')"
                      width="150px"
                    >
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </div>
        </el-tab-pane>
        
        <el-tab-pane>
          <h4 slot="label">{{ $t('agencyPc.noOfSubordinates') }}</h4>
           <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>{{ $t('agencyPc.month') }}</h3>
                    <el-date-picker @change="selecteDate" value-format="yyyy-MM"  v-model="average_depot_month" type="month" :placeholder="$t('agencyPc.selectmonth')" id="inputField">
                    </el-date-picker>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>{{ $t('agencyPc.noofdailyholders') }}</h3>
                  <p style="padding-top:10px;">{{ total_depot_users }}</p>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>{{ $t('agencyPc.day') }}</h3>
                  <p style="padding-top:10px;">{{ total_days }}</p>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>{{ $t('agencyPc.noofpositionsperday') }}</h3>
                  <p style="padding-top:10px;">{{ avarage_depot_users }}</p>
                </el-col>
              </el-row>
            </div>
               <div style="margin-top: 10px">
                  <el-table
                    :data="average_depot_people"
                    style="width: 100%">
                    <el-table-column
                      align="center"
                      prop="day"
                      :label="$t('agencyPc.date')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level1"
                      :label="$t('agencyPc.noofpeopleholding')">
                    </el-table-column>
                    <!-- <el-table-column
                      align="center"
                      prop="level2"
                      :label="$t('agencyPc.noofpeopleholdingtwo')">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level3"
                      :label="$t('agencyPc.noofpeopleholdingthree')">
                    </el-table-column> -->
                    <el-table-column
                      align="center"
                      prop="total"
                      :label="$t('agencyPc.dailysubtotal')">
                    </el-table-column>
                  </el-table>
                </div>

          </el-card>

        </el-tab-pane> 
      </el-tabs>
    </el-card>
    <!--    佣金提现-->
    <!-- <el-dialog :title="$t('agencyPc.commisionWithdrawal')" :visible.sync="withdrawState">
      <el-form
        ref="form"
        :model="withdrawalData"
        label-width="100px"
        size="small"
      >
        <el-form-item label-width="0">
          <h3>
            {{$t('agencyPc.useYourOwn')}}({{
              withdrawalData.account
            }}){{$t('agencyPc.bankCardWithdrawalInName')}}!<el-button
              type="primary"
              style="background-color: var(--baseColor);border-color:var(--baseColor)"
              class="right"
              @click="bankCardState = true"
              >{{$t('agencyPc.bankCardManagement')}}</el-button
            >
          </h3>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.bankName')}}:</h4>
          <p>{{ withdrawalData.name }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.accountOpeningBranch')}}:</h4>
          <p>{{ withdrawalData.address }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.bankCardNumber')}}:</h4>
          <p>{{ withdrawalData.card }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.accountName')}}:</h4>
          <p>{{ withdrawalData.account }}</p>
        </el-form-item>
        <br /><br />
        <el-form-item label-width="0">
          <h3>{{$t('agencyPc.fillWithdrawalAmount')}}</h3>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.accountBalance')}}:</h4>
          <p>{{ agent_account }}{{$t('operateday.yuan')}}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.withdrawalAmount')}}:</h4>
          <el-input
            v-model="withdrawalData.money"
            :placeholder="$t('agencyPc.fillWithdrawalAmount')"
            style="width: 200px"
          ></el-input>
          <p>{{$t('agencyPc.withdrawHundred')}}</p>
        </el-form-item>
        <el-form-item>
          <span slot="label" class="weigth">{{$t('agencyPc.withdrawPassword')}}:</span>
          <el-input
            :placeholder="$t('agencyPc.enterWithdrawalPassword')"
            v-model="withdrawalData.password"
            show-password
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="withdrawState = false" class="dialog-cancel">{{ $t('agencyPc.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="withdraw">{{$t('agencyPc.withdraw')}}</el-button>
      </div>
    </el-dialog> -->
    <!--    佣金划转-->
    <el-dialog :title="$t('agency.commissionTransfer')" :visible.sync="transferState">
      <el-form
        ref="form"
        :model="transferData"
        label-width="100px"
        size="small"
      >
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.fromProxyAmount')}}:</h4>
          <p>{{ agent_account }}{{$t('operateday.yuan')}}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.toPrincipalAccount')}}:</h4>
          <p>{{ cash }}{{$t('operateday.yuan')}}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('agencyPc.transferAmount')}}:</h4>
          <el-input
            v-model="transferData.number"
            :placeholder="$t('agencyPc.fillTransferAmount')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferState = false" class="dialog-cancel">{{ $t('agencyPc.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="transfer">{{ $t('agency.transfer') }}</el-button>
      </div>
    </el-dialog>
    <!--    银行卡管理-->
    <el-dialog :title="$t('agencyPc.bankCardManagement')" :visible.sync="bankCardState">
      <el-table :data="bankCardList">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column property="card" :label="$t('capital.cardNumber')"></el-table-column>
        <el-table-column property="name" :label="$t('agencyPc.bankName')"></el-table-column>
        <el-table-column property="address" :label="$t('agencyPc.accountOpeningBranch')"></el-table-column>
        <el-table-column :label="$t('capital.operate')">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              style="background-color: var(--baseColor);border-color:var(--baseColor)"
              @click="handleBankCard(scope.row)"
              >{{$t('stockrise.sure')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="$t('withdraw.modifyWithdrawPassword')"
      :visible.sync="withdrawalState"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item id="amountInput">
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="inputPayCode"
                autocomplete="off"
                :placeholder="$t('information.enterVerCode')"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <el-button
                :disabled="disabled3"
                type="info"
                style="width: 100%"
                @click="getPayCode"
                >{{ getPayCodeText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            type="password"
            v-model="inputPayPass"
            :placeholder="$t('information.enterPass')"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            type="password"
            v-model="inputPayConf"
            :placeholder="$t('information.enterConfPass')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptyPayPass" class="dialog-cancel">{{$t('rechargeau.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setPayPass">{{$t('rechargeau.sure')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('information.bindBankCard')"
      :visible.sync="bank.bankStatus"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form :model="bank">
        <el-form-item id="amountInput">
          <el-select v-model="bank.bankId" style="width: 100%">
            <el-option
              v-for="(item, index) in bank.bankList"
              :key="index"
              :value="item.id"
              :label="item.bank"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterBankCard')"
            v-model="bank.inputBankCode"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterAccountName')"
            v-model="bank.inputBankName"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterBranchName')"
            v-model="bank.inputBankAccess"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bank.bankStatus = false" class="dialog-cancel">{{$t('rechargeau.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setBank">{{$t('rechargeau.sure')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import JSEncrypt from "jsencrypt/bin/jsencrypt";
  import { Loading } from 'element-ui';
    export default {
        name: "agency",
      data(){
        return{
          agencyUrl:'',
          agencyUrlSub: '',
          code:'',
          //管理费
          manageData: [],
          commissionDetails: [],
          withdrawData:[],
          voucherData:[],
          inputPayCode: '',
          getPayCodeText: this.$t('forgotPassword.getVerificationCode'), //
          inputPayPass: '',
          inputPayConf: '',
          //递延费
          deferredData:[],
          //利润分成
          dividedData:[],
          //我的会员
          teamData:[],
          //充值会员,
          rechargeTeamData:[],
          //无充值会员
          noRechargeTeamData:[],
          //一级会员
          levelOne:0,
          //二级会员
          levelTwo:0,
          //三级会员
          levelThree:0,
          //今日会员
          todayNum:0,
          //代理佣金
          agent_account:0,
          cash:0,
          //对话框佣金提现状态
          withdrawState:false,
          withdrawalState: false,
          //对话框佣金划转状态
          transferState:false,
          //银行卡管理状态
          bankCardState:false,
          bankSet: false,
          //提现
          withdrawalData:{
            name:'',
            card:'',
            address:'',
            account:'',
            money:'',
            password:'',
            bankStatus: false,
            isWithdrawalData: false,
          },

          bank: {
            bankId: "",
            inputBankCode: "",
            inputBankName: "",
            inputBankAccess: "",
            bankList: [],
            bankStatus: false,
          },
          //划转
          transferData:{
            number:''
          },
          formLabelWidth:'120px',
          //银行卡列表
          bankCardList:[],
          disabled3: false,
          couponAmount: "",
          couponNo: "",
          couponCheck : false,
          subUrl: "",
          isFromCoupon: false,
          wit_total:0,
          manage_total:0,
          deferred_total:0,
          divide_total:0,
          average_depot_people: [],
          average_depot_month: "",
          total_depot_users: 0,
          avarage_depot_users: 0,
          total_days: 0,
        }
      },
      computed:{
      },
      methods: {
        bankFadeIn() {
          let that = this;
          that
            .$http({
              url: "/app/UserBank/bank_info",
              method: "post",
              data: {

              },
            })
            .then(function (res) {
              if (res.data.status == 200) {
                that.bank.bankList = res.data.data.bank;
                that.bank.bankId = that.bank.bankList[0].id;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        setBank() {
          let that = this;
          if (that.bank.inputBankCode == "") {
            that.$message.error(that.$t('capital.enterBankCardNum'));
          } else if (that.bank.inputBankName == "") {
            that.$message.error(that.$t('capital.nameAccHolder'));
          } else if (that.bank.inputBankAccess == "") {
            that.$message.error(that.$t('capital.enterBankAddress'));
          } else {
            that
              .$http({
                url: "/app/Bank/bind_bank",
                method: "post",
                data: {
                  name: that.bank.inputBankName,
                  bank_id: that.bank.bankId,
                  address: that.bank.inputBankAccess,
                  card: that.bank.inputBankCode,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.bank.bankStatus = false;
                      that.withdrawalData.bankStatus = true;
                      that.getAccountBank();
                    },
                  });
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          }
        },
        encryptMessage(message, publicKey) {
          const jsEncrypt = new JSEncrypt();
          jsEncrypt.setPublicKey(publicKey);
          return jsEncrypt.encrypt(message);
        },
        getPayCode() {
          let that = this;
          that.disabled3 = true;
          clearInterval(window.timer2);

          let publicKey = localStorage.getItem("encript_public_key");
          let userPhone = that.inputLoginPhone.toString();
          let inputPhone = that.encryptMessage(userPhone, publicKey);

          that
            .$http({
              url: "/app/SendSms/modifyinfo_code_e",
              method: "post",
              data: {
                info: inputPhone,
                type: 1,
              },
            })
            .then(function (res) {
              if (res.data.status == 200) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  duration: 2000,
                });
                var time = 60;
                that.getPayCodeText = time + "s";
                window.timer2 = setInterval(function () {
                  time--;
                  that.getPayCodeText = time + "s";
                  if (time <= 0) {
                    clearInterval(window.timer2);
                    that.disabled3 = false;
                    that.getPayCodeText = that.$t('forgotPassword.getVerificationCode');
                  }
                }, 1000);
              } else {
                that.$message.error(that.$t(res.data.msgId));
                that.disabled3 = false;
              }
            });
        },
        getConfig() {
          console.log("dasds")
          let that = this;
          that
            .$http({
              url: "/app/User/user_info",
              method: "post",
              data: {

              },
            })
            .then(function (res) {
              if (res.data.status == 200) {
                console.log(res.data)
                that.inputLoginPhone = res.data.data.phone1;

                if (res.data.data.withdrawal == 0) {
                  that
                    .$confirm(that.$t('withdraw.withdrawPasswordNotset'), {
                      confirmButtonText: that.$t('trading.sure'),
                      cancelButtonText: that.$t('capitalAccountDetails.cancel'),
                      type: "warning",
                      confirmButtonClass: "dialogConfirm",
                      cancelButtonClass: "dialogCancel"
                    })
                    .then(() => {
                      that.withdrawalState = true;
                    })
                    .catch(() => {
                      if (res.data.data.bank == 0) {
                        that.showBankCardPopup();
                      }
                      that.getAccountBank();
                    });
                } else {
                  that.getAccountBank();
                }
                
                if (res.data.data.bank != 0) {
                  //已绑定
                  that.withdrawalData.bankStatus = true;
                } else {
                  
                  //未绑定
                  that.bankSet = true;
                  that.withdrawalData.bankStatus = false;
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        emptyPayPass() {
          let that = this;
          that.inputPayCode = "";
          that.inputPayConf = "";
          that.inputPayPass = "";
          that.withdrawalState = false;
        },
        showBankCardPopup() {
          let that = this;
          if (
            !that.withdrawalData.isWithdrawalData
          ) {
            that
              .$confirm(that.$t('withdraw.bankNotBound'), that.$t('capital.hint'), {
                confirmButtonText: that.$t('trading.sure'),
                cancelButtonText: that.$t('capitalAccountDetails.cancel'),
                confirmButtonClass: "dialogConfirm",
                cancelButtonClass: "dialogCancel",
                type: "warning",
              })
              .then(() => {
                that.bank.bankStatus = true;
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: that.$t('capital.unDeleted'),
                });
              });
          }
        },
        setPayPass() {
          let that = this;
          if (that.inputPayCode == "") {
            that.$message.error(that.$t('modifyWithdrawPassword.verificationLable'));
          } else if (that.inputPayPass == "") {
            that.$message.error(that.$('modifyLoginPassword.enterPasswordLable'));
          } else if (that.inputPayConf == "") {
            that.$message.error(that.$t('capital.enterConfirmationPw'));
          } else if (that.inputPayConf != that.inputPayPass) {
            that.$message.error(that.$t('capital.inconsistentPw'));
          } else {
            let publicKey = localStorage.getItem("encript_public_key");
            let inputPassWord = that.encryptMessage(that.inputPayPass, publicKey);
            let inputPassWordCon = that.encryptMessage(
              that.inputPayConf,
              publicKey
            );
            that
              .$http({
                url: "/app/User/modify_pay_e",
                method: "post",
                data: {
                  password: inputPassWord,
                  confirm: inputPassWordCon,
                  code: that.inputPayCode,
                  phone: that.inputLoginPhone
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.withdrawalState = false;
                    },
                  });
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          }
        },
        selecteDate(date){
          // this.average_depot_month = date.getTime();
          this.getAverageDepotPeople();
        },
        parse_url(_url){
          var pattern = /(\w+)=(\w+)/ig;//定义正则表达式
          var parames = {};//定义数组
          _url.replace(pattern, function(a, b, c){
            parames[b] = c;
          });
          return parames;//返回这个数组.
        },
        getCode() {
          let that = this;
          that.code = that.parse_url(that.agencyUrl).code;
        },
        qrcode(url) {
          let qrcode = new QRCode('qrcode', {
            width: 200,
            height: 200,
            text: url, // 二维码地址
          })
        },
        getAgencyUrl(){

          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_qrcode",
              method: "get",
              data: {
                
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.agencyUrl = resData.pc_url;
                sessionStorage.setItem("qrcodeUrl",that.agencyUrl);
                var subUrl = sessionStorage.getItem("qrcodeUrl");
                that.$store.commit("qrCodeUrl", subUrl);
                that.subUrlMethod();
                that.qrcode(that.agencyUrl);
                that.getCode();
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },

        getUserUrl(){

          let that = this;
          that
            .$http({
              url: "/app/UserCoupon/my_coupon",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 1) {
                that.agencyUrl = resData.data;
                that.agencyUrl = that.agencyUrl.split('=')[0]+"?code=";
                sessionStorage.setItem("qrcodeUrl",that.agencyUrl);
                var subUrl = sessionStorage.getItem("qrcodeUrl");
                that.$store.commit("qrCodeUrl", subUrl);
                that.subUrlMethod();
                that.qrcode(that.agencyUrl);
                that.getCode();
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },

        subUrlMethod(){
          let that = this;
          that.subUrl = this.$store.state.qrCodeUrl;
          // that.agencyUrlSub = that.subUrl.substr(0, 42);
          that.agencyUrlSub = that.subUrl.split('=')[1];
          // that.agencyUrlSub = that.agencyUrlSub + "=";
          if(that.$store.state.couponNo) {
            that.couponCheck = true;
            // that.agencyUrlSub = that.subUrl.substr(0, 42);
            that.agencyUrlSub = that.subUrl.split('=')[0];
            that.agencyUrlSub = that.agencyUrlSub + "=";
            that.agencyUrl = that.agencyUrlSub.concat(that.$store.state.couponNo);
            that.agencyUrlSub = that.agencyUrl;
          }
        },

        //获取管理费
        getManageData(){
          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_commissioninfo",
              method: "post",
              data: {
                
                flag:'manage'
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.manageData = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },

        // Get summary agent commission details
        getcommissionDetails(){
          let that = this;
          that
            .$http({
              url: "/app/AgentFlowLog/agent_flow_log",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.commissionDetails = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },

        getWithdrawData(){
          let that = this;
          that
            .$http({
              url: "/app/AgentWithdraw/agent_withdraw",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.withdrawData = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        //获取递延费数据
        getDeferred(){
          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_commissioninfo",
              method: "post",
              data: {
               
                flag:'deferred'
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.deferredData = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        //获取利润分成数据
        getDividedData(){
          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_commissioninfo",
              method: "post",
              data: {
                
                flag:'divided'
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.dividedData = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        getVoucherData(){
          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_commissioninfo",
              method: "post",
              data: {
                
                flag:'voucher'
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                that.voucherData = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        //复制
        handleCopy(copy){
          let text = copy;
          let oInput = document.createElement('input');
          oInput.value = text;
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand("Copy");
          this.$message({
            message: this.$t('agencyPc.copySuccess'),
            type: 'success'
          });
          oInput.remove()
        },
        //获取我的会员
        getAgentTeam(){
          let that = this;
          that
            .$http({
              url: "/app/Agent/agent_team",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                let teamData = resData.data;
                that.teamData = teamData;
                let levelOne = 0;
                let levelTwo = 0;
                let levelThree = 0;
                let todayNum = 0;
                let rechargeTeamData = [];
                let noRechargeTeamData = [];
                for (let i = 0,len = teamData.length;i < len; i++){
                  switch (teamData[i].level.substring(0,1)) {
                    case '一':
                      levelOne = levelOne + 1;
                    break;
                    case '二':
                      levelTwo = levelTwo + 1;
                      break;
                    case '三':
                      levelThree = levelThree + 1;
                      break;
                  }
                  if (that.isToday(teamData[i].time)){
                    todayNum = todayNum + 1;
                  }

                  if (teamData[i].rec_total == 0){
                    noRechargeTeamData.push(teamData[i])
                  }else{
                    rechargeTeamData.push(teamData[i])
                  }
                }
                //1级会员
                that.levelOne = levelOne;
                //2级会员
                that.levelTwo = levelTwo;
                //3级会员
                that.levelThree = levelThree;
                //今日会员
                that.todayNum = todayNum;
                //充值会员
                that.rechargeTeamData = rechargeTeamData;
                //无充值会员
                that.noRechargeTeamData = noRechargeTeamData;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        //判断是否是今天
        isToday(str){
          let that = this;
          return that.$moment(that.$moment(str, "YYYY.MM.DD HH:mm:ss").format('YYYY-MM-DD')).isSame(that.$moment().tz("Asia/Shanghai").format("YYYY-MM-DD"));
        },
        //获取用户基本信息
        getUserinfo() {
          let that = this;
          that.$http({
              url: "/app/User/user",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function(res) {
              if (res.data.status == 200) {
                that.cash = res.data.data.cash;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        //获取用户银行卡
        getAccountBank(){
          let that = this;
          that.$http({
              url: "/app/UserBank/accountbank",
              method: "post",
              data: {
                
              },transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function(res) {
              if (res.data.status == 200) {
                that.bankCardList = res.data.data;
                that.withdrawalData.account = that.bankCardList[0].account;
                that.withdrawalData.card = that.bankCardList[0].card;
                that.withdrawalData.name = that.bankCardList[0].name;
                that.withdrawalData.address = that.bankCardList[0].address;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            })
        },
        handleBankCard(row){
          let that = this;
          that.withdrawalData.account = row.account;
          that.withdrawalData.card = row.card;
          that.withdrawalData.name = row.name;
          that.withdrawalData.address = row.address;
          that.bankCardState = false;
        },
        //佣金提现
        // withdraw(){
        //   let loadingInstance = Loading.service({ fullscreen: true });
        //   let that = this;
        //   let number = that.withdrawalData.money;
        //   let password = that.withdrawalData.password;
        //   let name = that.withdrawalData.name;
        //   let card = that.withdrawalData.card;
        //   that.$http({
        //       url: "/app/AgentWithdraw/agent_dowithdraw",
        //       method: "post",
        //       data: {
                
        //         number: number,
        //         password: password,
        //         name: name,
        //         card: card
        //       },transformRequest: [(data) => JSON.stringify(data)]
        //     })
        //     .then(function(res) {
        //       if (res.data.status == 200) {
        //         that.$message({
        //           message: that.$t(res.data.msgId),
        //           type: 'success',
        //           onClose:function () {
        //               that.withdrawState = false;
        //               that.withdrawalData.money = '';
        //               that.withdrawalData.password = '';
        //               that.getWithdrawData();
        //               that.getUserinfo();
        //               that.getAgentAccount();
        //           }
        //         });
        //       } else {
        //         that.$message.error(that.$t(res.data.msgId));
        //       }

        //       setTimeout(() => {
        //         loadingInstance.close();
        //       }, 500);
              
        //     });
        // },
        //佣金划转
        transfer(){
          let that = this;
          let loadingInstance = Loading.service({ fullscreen: true });
          let number = Number(that.transferData.number).toFixed(2);
          if (number <= 0 || isNaN(number)){
            that.$message.error(this.$t('agencyPc.enterCorrectAmount'));
          }else{
            that.$http({
              url: "/app/AgentWithdraw/transfer_money",
              method: "post",
              data: {
                
                number: number,
              },transformRequest: [(data) => JSON.stringify(data)]
            })
              .then(function(res) {
                if (res.data.status == 200) {
                  that.transferState = false;
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: 'success',
                    onClose:function () {
                      that.transferData.number = '';
                      that.getUserinfo();
                      that.getAgentAccount();
                      that.getWithdrawData();
                      
                    }
                  });
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }

                
              
              });
          }

          setTimeout(() => {
            loadingInstance.close();
          }, 500);

        },

        getAgentAccount(){
          let that = this;
          that.$http({
            url: "/app/AgentAccount/agent_account",
            method: "get",
            data: {
              
            }
          })
            .then(function(res) {
              if (res.data.status == 200) {
                that.agent_account = res.data.data.account;
                that.wit_total = res.data.data.wit_total;
                that.manage_total = res.data.data.manage_total;
                that.deferred_total = res.data.data.deferred_total;
                that.divide_total = res.data.data.divide_total;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },

        getAverageDepotPeople(){
          let that = this;
          that
            .$http({
              url: "/app/AgentDailyDepot/agent_daily_depot",
              method: "post",
              data: {
                  date: that.average_depot_month,
                  num: null,
                  page: null},
              transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function (res) {
              if (res.data.status == 200) {
                that.average_depot_people = res.data.data.data;
                that.avarage_depot_users = res.data.data.avarage_depot_users;
                that.total_days = res.data.data.total_days;
                that.total_depot_users = res.data.data.total_depot_users;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        }
      },
      created() {
        this.couponAmount = this.$store.state.couponAmount;
        this.couponNo = this.$store.state.couponNo;
      },
      mounted () {
        if(this.$store.state.couponNo) {
          this.getUserUrl();
        } else {
          this.getAgencyUrl();
        }

        this.bankFadeIn();
// if(this.couponCheck == false)
// var cols = document.getElementsByClassName('col1');
//   for(i = 0; i < cols.length; i++) {
//     cols[i].style.backgroundColor = 'blue';
//   }
        //获取推广地址


        // var subUrl = sessionStorage.getItem("qrcodeUrl");


        //获取管理费数据
        this.getManageData();
        //get agent commission detals
        this.getcommissionDetails();
        //get agent withdraw data
        this.getWithdrawData();
        //获取递延费数据
        this.getDeferred();
        //获取利润分成数据
        this.getDividedData();
        //获取我的会员
        this.getAgentTeam();
        //获取用户详细数据
        this.getUserinfo();
        //获取银行卡列表
        this.getAccountBank();

        this.getAgentAccount();
        //get agent voucher data
        this.getVoucherData();

        this.getAverageDepotPeople();


      },
      beforeDestroy() {
        this.$store.state.couponNo = "";
        this.$store.state.couponAmount = "";
      },
    }
</script>

<style scoped>
.agency_title {
  text-align: center;
}
.agency_qrcode {
  width: 200px;
  margin: 25px 0;
}
.weigth {
  font-weight: bold;
}

.box-card {
  border-radius: 8px;
  border: none;
  background-color: transparent;
}

.box-card >>> .el-card__header {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
}

.box-card >>> .el-card__body {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
}

.content_title {
  /* font-size: 18px; */
  text-align: left;
}

.secondTabDetailBox {
  background: var(--baseColor);
  padding: 20px 25px;
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin: 10px 0px 15px;
}

.secondTabDetailBox p {
  text-align: left;
}
#couponTabs>>>.el-tabs--card>.el-tabs__header .el-tabs__nav {
  background-color: #E9E9F0;
  border-radius: 25px;
  padding: 3px 7px;
}
#couponTabs>>>.el-tabs--card>.el-tabs__header {
  border: none;
  margin-bottom: 25px
}
.integer-value {
  font-size: 20px;
  font-weight: 500;
}
.decimal-value {
  font-size: 16px;
  font-weight: 500;
  margin-left: -5px;
}
#inputField>>>.el-input__inner:focus {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:hover {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:active {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-range-editor.is-active {
  border-color: var(--baseColor) !important;
}

.dialog-cancel:hover {
  color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
  background-color: #fff !important;
}

</style>
<style>
#agencyTabs .el-tabs__active-bar {
  display: none;
  background-color: var(--baseColor);
}

#agencyTabs .el-tabs__item.is-active {
  color: var(--baseColor);
}
#agencyTabs .el-tabs__item:hover {
  color: var(--baseColor) !important;
}

#agencyTabs .el-tabs__item.is-active:after {
  height: 3px;
  display: block;
  width: auto;
  background: var(--baseColor);
  content: "";
  border-radius: 5px;
  width: 45px;
  display: block;
  margin: 0 auto;
  top: -4px;
  position: relative;
}
#couponTabs .el-tabs__item.is-active {
  color: #FFFFFF;
  background-color: var(--baseColor) !important;
  border-radius: 25px;
}
/* agency myteam tab mouseover issue fix */
#couponTabs .el-tabs__item.is-active:hover {
  color: #FFFFFF!important;
}
.el-input__inner:focus {
  border-color: var(--baseColor) !important;
}
.el-month-table td.current:not(.disabled) .cell {
  color: var(--baseColor) !important;
}
.el-month-table td.today .cell {
  color: var(--baseColor) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/agency.vue